<template>
    <form class="section-hom-form form-horizontal" @submit.prevent="handleSubmit">
        <!-- Card 1 -->
        <div class="panel panel-default">
            <div class="panel-heading ph1">
                <h3 class="panel-title">Card 1 <span class="badge">Mínimo 1 link</span></h3>
                <div class="help-block error-message" v-for="e in errors.card1.link" :key="e">{{ e }}</div>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="title" class="col-sm-2 control-label">Título</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="title" v-model="card1.title">
                        <div class="help-block error-message" v-for="e in errors.card1.title" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">Link 1 activo</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card1.showLink1" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div v-if="card1.showLink1">
                    <div class="form-group">
                        <label for="nombre_link1" class="col-sm-2 control-label">Texto link 1</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="nombre_link1" v-model="card1.nombreLink1">
                            <div class="help-block error-message" v-for="e in errors.card1.nombreLink1" :key="e">{{ e }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="tramite1" class="col-sm-2 control-label">URL</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="url1" v-model="card1.selectedTramite1">
                            <div class="help-block error-message" v-for="e in errors.card1.selectedTramite1" :key="e">{{ e }}</div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">Link 2 activo</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card1.showLink2" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div v-if="card1.showLink2">
                    <div class="form-group">
                        <label for="nombre_link2" class="col-sm-2 control-label">Texto link 2</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="nombre_link2" v-model="card1.nombreLink2">
                            <div class="help-block error-message" v-for="e in errors.card1.nombreLink2" :key="e">{{ e }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="tramite2" class="col-sm-2 control-label">URL</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="url2" v-model="card1.selectedTramite2">
                            <div class="help-block error-message" v-for="e in errors.card1.selectedTramite2" :key="e">{{ e }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card 2 -->
        <div class="panel panel-default">
            <div class="panel-heading ph2">
                <h3 class="panel-title">Card 2 <span class="badge">Mínimo 1 link</span></h3>
                <div class="help-block error-message" v-for="e in errors.card2.link" :key="e">{{ e }}</div>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="title" class="col-sm-2 control-label">Título</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="title" v-model="card2.title">
                        <div class="help-block error-message" v-for="e in errors.card2.title" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">Link 1 activo</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card2.showLink1" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div v-if="card2.showLink1">
                    <div class="form-group">
                        <label for="nombre_link1" class="col-sm-2 control-label">Texto link 1</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="nombre_link1" v-model="card2.nombreLink1">
                            <div class="help-block error-message" v-for="e in errors.card2.nombreLink1" :key="e">{{ e }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="tramite1" class="col-sm-2 control-label">URL</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="url1" v-model="card2.selectedTramite1">
                            <div class="help-block error-message" v-for="e in errors.card2.selectedTramite1" :key="e">{{ e }}</div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">Link 2 activo</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card2.showLink2" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div v-if="card2.showLink2">
                    <div class="form-group">
                        <label for="nombre_link2" class="col-sm-2 control-label">Texto link 2</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="nombre_link2" v-model="card2.nombreLink2">
                            <div class="help-block error-message" v-for="e in errors.card2.nombreLink2" :key="e">{{ e }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="tramite2" class="col-sm-2 control-label">URL</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="url2" v-model="card2.selectedTramite2">
                            <div class="help-block error-message" v-for="e in errors.card2.selectedTramite2" :key="e">{{ e }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card 3 -->
        <div class="panel panel-default">
            <div class="panel-heading ph3">
                <h3 class="panel-title">Card 3 <span class="badge">Mínimo 1 link</span></h3>
                <div class="help-block error-message" v-for="e in errors.card3.link" :key="e">{{ e }}</div>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="title" class="col-sm-2 control-label">Título</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="title" v-model="card3.title">
                        <div class="help-block error-message" v-for="e in errors.card3.title" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">Link 1 activo</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card3.showLink1" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div v-if="card3.showLink1">
                    <div class="form-group">
                        <label for="nombre_link1" class="col-sm-2 control-label">Texto link 1</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="nombre_link1" v-model="card3.nombreLink1">
                            <div class="help-block error-message" v-for="e in errors.card3.nombreLink1" :key="e">{{ e }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="tramite1" class="col-sm-2 control-label">URL</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="url1" v-model="card3.selectedTramite1">
                            <div class="help-block error-message" v-for="e in errors.card3.selectedTramite1" :key="e">{{ e }}</div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">Link 2 activo</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card3.showLink2" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div v-if="card3.showLink2">
                    <div class="form-group">
                        <label for="nombre_link2" class="col-sm-2 control-label">Texto link 2</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="nombre_link2" v-model="card3.nombreLink2">
                            <div class="help-block error-message" v-for="e in errors.card3.nombreLink2" :key="e">{{ e }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="tramite2" class="col-sm-2 control-label">URL</label>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" id="url2" v-model="card3.selectedTramite2">
                            <div class="help-block error-message" v-for="e in errors.card3.selectedTramite2" :key="e">{{ e }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/sections-admin-page-contents/home">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            card1: {
                title: '',
                showLink1: true,
                nombreLink1: '',
                selectedTramite1: null,
                showLink2: false,
                nombreLink2: '',
                selectedTramite2: null,
            },
            card2: {
                title: '',
                showLink1: true,
                nombreLink1: '',
                selectedTramite1: null,
                showLink2: false,
                nombreLink2: '',
                selectedTramite2: null,
            },
            card3: {
                title: '',
                showLink1: true,
                nombreLink1: '',
                selectedTramite1: null,
                showLink2: false,
                nombreLink2: '',
                selectedTramite2: null,
            },
            errors: {
                card1: {
                    title: [],
                    link: [],
                    nombreLink1: [],
                    selectedTramite1: [],
                    nombreLink2: [],
                    selectedTramite2: [],
                },
                card2: {
                    title: [],
                    link: [],
                    nombreLink1: [],
                    selectedTramite1: [],
                    nombreLink2: [],
                    selectedTramite2: [],
                },
                card3: {
                    title: [],
                    link: [],
                    nombreLink1: [],
                    selectedTramite1: [],
                    nombreLink2: [],
                    selectedTramite2: [],
                },
            },
        };
    },
    mounted() {
        this.initializeForm();
    },
    methods: {
        initializeForm() {
            // Asegúrate de que options tenga al menos 3 elementos
            if (this.options.length >= 3) {
                this.card1 = {
                    title: this.options[0].title,
                    showLink1: this.options[0].isOnFirst === 1,
                    nombreLink1: this.options[0].texturl1,
                    selectedTramite1: this.options[0].url1,
                    showLink2: this.options[0].isOnSecond === 1,
                    nombreLink2: this.options[0].texturl2,
                    selectedTramite2: this.options[0].url2,
                };

                this.card2 = {
                    title: this.options[1].title,
                    showLink1: this.options[1].isOnFirst === 1,
                    nombreLink1: this.options[1].texturl1,
                    selectedTramite1: this.options[1].url1,
                    showLink2: this.options[1].isOnSecond === 1,
                    nombreLink2: this.options[1].texturl2,
                    selectedTramite2: this.options[1].url2,
                };

                this.card3 = {
                    title: this.options[2].title,
                    showLink1: this.options[2].isOnFirst === 1,
                    nombreLink1: this.options[2].texturl1,
                    selectedTramite1: this.options[2].url1,
                    showLink2: this.options[2].isOnSecond === 1,
                    nombreLink2: this.options[2].texturl2,
                    selectedTramite2: this.options[2].url2,
                };
            } else {
                console.error('Not enough data provided in options');
            }
        },
        handleSubmit() {
            this.validateForm();
            if (
                this.errors.card1.title.length === 0 &&
                this.errors.card1.nombreLink1.length === 0 &&
                this.errors.card1.link.length === 0 &&
                this.errors.card1.selectedTramite1.length === 0 &&
                this.errors.card1.nombreLink2.length === 0 &&
                this.errors.card1.selectedTramite2.length === 0 &&
                this.errors.card2.title.length === 0 &&
                this.errors.card2.link.length === 0 &&
                this.errors.card2.nombreLink1.length === 0 &&
                this.errors.card2.selectedTramite1.length === 0 &&
                this.errors.card2.nombreLink2.length === 0 &&
                this.errors.card2.selectedTramite2.length === 0 &&
                this.errors.card3.title.length === 0 &&
                this.errors.card3.link.length === 0 &&               
                this.errors.card3.nombreLink1.length === 0 &&
                this.errors.card3.selectedTramite1.length === 0 &&
                this.errors.card3.nombreLink2.length === 0 &&
                this.errors.card3.selectedTramite2.length === 0
            ) {
                const data = {
                    card1: this.card1,
                    card2: this.card2,
                    card3: this.card3,
                };
                axios({
                    url: '/backend/new-home/destacamos/edit',
                    method: 'POST',
                    data: data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }
        },
        validateForm() {
            this.errors.card1 = this.validateCard(this.card1);
            this.errors.card2 = this.validateCard(this.card2);
            this.errors.card3 = this.validateCard(this.card3);
        },
        isValidUrl(url) {
            const expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
            const regex = new RegExp(expression);
            return regex.test(url);
        },
        validateCard(card) {
            const errors = {
                title: [],
                link: [],
                nombreLink1: [],
                selectedTramite1: [],
                nombreLink2: [],
                selectedTramite2: [],
            };
            if (!card.title) {
                errors.title.push('La tarjeta debe tener título');
            }
            if (card.showLink1) {
                if (!card.nombreLink1) {
                    errors.nombreLink1.push('Texto de link obligatorio');
                }
                if (!card.selectedTramite1) {
                    errors.selectedTramite1.push('Debes Ingresar una URL');
                }
                if (!this.isValidUrl(card.selectedTramite1)) {
                    errors.selectedTramite1.push('La URL debe ser válida y comenzar con https://');
                }
            }
            if (card.showLink2) {
                if (!card.nombreLink2) {
                    errors.nombreLink2.push('Texto de link obligatorio');
                }
                if (!card.selectedTramite2) {
                    errors.selectedTramite2.push('Debes seleccionar un tramite');
                }
                if (!this.isValidUrl(card.selectedTramite2)) {
                    errors.selectedTramite2.push('La URL debe ser válida y comenzar con https://');
                }
            }
            if (!card.showLink1 && !card.showLink2){
                errors.link.push('Debe haber al menos 1 link activo');
            }
            return errors;
        },
    },
}
</script>

<style lang="scss" scoped>
    .el-select {
        display: block;
    }
    .ph1 {
        background-color: #ddf6f3;
    }
    .ph3 {
        background-color: #d9edf7;
    }
    .error-message {
        color: red;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
